import {TransactionalInterface, WebhookNotificationTO} from "@/interfaces/Transactional.interface";
import api from "../config";

export class PaymentRest{
    getAllTransactions(params: any): Promise<any> {
        return api.get('/payment', { params }).then((response) => response.data);
    }

    createPayment(amountCredit: number): Promise<any> {
        let config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        return api.post('/payment', amountCredit, config).then((response) => response.data);
    }

    createPaymentCoupon(code: string): Promise<any> {
        return api.post(`/payment/coupon/${code}`).then((response) => response.data);
    }

    getNotify(notification: WebhookNotificationTO, transactional: any): Promise<any> {
        return api.post(`/payment/notify/${transactional}`, notification).then((response) => response.data);
    }
}